export default __webpack_public_path__ + "static/media/location.8e491d77.svg";